'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _helpers = require('./_helpers');

var _swiperEsm = require('swiper/dist/js/swiper.esm.js');

/* prettier-ignore */
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var swiperContainer = context.getElement('.' + context.className + '_Carousel');
  var swiperThumbsNextButton = context.getElement('.' + context.className + '_ThumbsButton-next');
  var swiperThumbsPreviousButton = context.getElement('.' + context.className + '_ThumbsButton-previous');
  var swiperThumbsButtons = [swiperThumbsNextButton, swiperThumbsPreviousButton].filter(Boolean);
  var swiperPaging = context.getElement('.' + context.className + '_Paging');
  var thumbnailList = context.getElement('.' + context.className + '_ThumbItems');
  var thumbnailItems = context.getElements('.' + context.className + '_ThumbItem');
  var addToBox = document.querySelector('.js-BuildABox_Add');

  /** @note Swiper doesn't initialise correctly on Safari without waiting at least 1ms */
  setTimeout(function () {
    var mainCarousel = (0, _helpers.initialiseSwiper)(swiperContainer, {
      loop: false,
      slidesPerView: 1,
      slideClass: context.className + '_Slide',
      pagination: {
        el: swiperPaging,
        type: 'bullets',
        clickable: true,
        bulletClass: 'prd-ProductImage_Bullet',
        bulletActiveClass: 'prd-ProductImage_Bullet-active'
      }
    }, [_swiperEsm.Pagination]);

    function setThumbnailVisibility(activeIndex) {
      var totalVisibleThumbnails = 5;
      var totalThumbnails = thumbnailItems.length;

      var lastIndexToScrollTo = Math.max(totalThumbnails - totalVisibleThumbnails, 0);
      var topThumbnailIndex = activeIndex > lastIndexToScrollTo ? lastIndexToScrollTo : activeIndex;

      var offsetPerSlide = 50 + 10; // slide height (50px) + gap between slides (10px)

      thumbnailItems.forEach(function (slide, index) {
        var state = 'visible';
        if (index === activeIndex) {
          state = 'active';
        } else if (index === topThumbnailIndex - 1 || index === topThumbnailIndex + totalVisibleThumbnails) {
          state = 'faded';
        } else if (index < topThumbnailIndex || index > topThumbnailIndex + totalVisibleThumbnails) {
          state = 'hidden';
        }

        slide.dataset.state = state;
      });

      var translate = 'translate3d(0px, ' + offsetPerSlide * topThumbnailIndex * -1 + 'px, 0px)';
      thumbnailList.style.setProperty('--ThumbItems_Transform', translate, 'important');
    }

    function setArrowVisibility(activeIndex) {
      if (swiperThumbsButtons.length === 0) {
        return;
      }

      swiperThumbsPreviousButton.style.visibility = activeIndex === 0 ? 'hidden' : 'visible';
      swiperThumbsNextButton.style.visibility = activeIndex === thumbnailItems.length - 1 ? 'hidden' : 'visible';
    }

    setThumbnailVisibility(0);
    setArrowVisibility(0);

    mainCarousel.on('slideChange', function () {
      var activeIndex = mainCarousel.activeIndex;

      setThumbnailVisibility(activeIndex);
      setArrowVisibility(activeIndex);
    });

    swiperThumbsButtons.forEach(function (button) {
      var direction = button === swiperThumbsNextButton ? 'next' : 'previous';

      button.addEventListener('click', function () {
        if (direction === 'next') {
          mainCarousel.slideNext();
        } else {
          mainCarousel.slidePrev();
        }
      });
    });

    thumbnailItems.forEach(function (thumbnail, index) {
      thumbnail.addEventListener('click', function () {
        mainCarousel.slideTo(index);
      });
    });

    addToBox.addEventListener('click', onButtonClick);

    function onButtonClick() {
      setTimeout(function () {
        mainCarousel.update();
      }, 1);
    }

    window.addEventListener('load', function () {
      mainCarousel.update();
    });
  }, 1);
}